module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if(show_header) { 
__p+='\n	<div class="page-header">\n		<p class="title">Congratulations, your league '+
((__t=( name ))==null?'':_.escape(__t))+
' </br> has been created</p>\n	</div>\n';
 } 
__p+='\n<form class="league-join-table base-form page-grid">\n\n	<div class="form-group one-line">\n		<div class="form-part">\n			<label>League PIN</label>\n			<input  type="text" class="base-text-input js-league-code" name="league_code" value="'+
((__t=( code ))==null?'':_.escape(__t))+
'" disabled>\n		</div>\n\n		<div class="form-part">\n			<div class="copied js-copied-code hidden">Copied!</div>\n			<a href="javascript:void(0)" class="base-btn tertiary-btn js-copy-league-code">COPY</a>\n		</div>\n\n		<div class="tooltip-bar">\n			<div class="tooltip-text">\n				<h4>League PIN</h4>\n				<p>Share your League PIN with others to allow them to join your league</p>\n			</div>\n			<span class="tooltip-icon">?</span>\n		</div>\n\n	</div>\n\n	<div class="buttons-wrapper" >\n		<a href="/fantasy/team" class="base-btn secondary-btn" >Back to My Team</a>\n		<a href="/fantasy/league/'+
((__t=( id ))==null?'':_.escape(__t))+
'/manage" class="base-btn primary-btn" data-value="advanced" >View League</a>\n	</div>\n\n</form>\n';
}
return __p;
};
